import React, { FC } from 'react';
import { ProjectCountryResponsibleProps } from './ProjectCountryResponsibleProps';
import ResponsibleField from '../ResponsibleTab/ProjectResponsibleForm/ResponsibleField';
import useTranslation from '../../hooks/useTranslation';

const ProjectCountryResponsible: FC<ProjectCountryResponsibleProps> = ({
  usersList,
  required,
}) => {
  const t = useTranslation();
  return (
    <ResponsibleField
      field={'countryProjectResponsible'}
      label={t('ppm.columns.responsible')}
      usersList={usersList}
      required={required}
    />
  );
};

export default ProjectCountryResponsible;
